import { render, staticRenderFns } from "./ChemUBC154ElectrochemPLQ3.vue?vue&type=template&id=4a46c36d&scoped=true&"
import script from "./ChemUBC154ElectrochemPLQ3.vue?vue&type=script&lang=js&"
export * from "./ChemUBC154ElectrochemPLQ3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a46c36d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VSelect})
